import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f3d4774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chains" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "chains-title" }, " Supported Networks ", -1))
const _hoisted_3 = { class: "chains-names" }
const _hoisted_4 = ["src", "alt"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Chains',
  setup(__props) {


const chains = [
  'Ethereum',
  'Polygon',
  'Arbitrum',
  'Optimism',
  'Cronos',
  'Base',
  'Mantle',
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chains, (chain) => {
        return _createElementVNode("div", {
          key: chain,
          class: _normalizeClass(`chain-box chain-box--${chain}`)
        }, [
          _createElementVNode("img", {
            src: require(`@/assets/chains/${chain}.svg`),
            alt: chain,
            class: "chain-logo"
          }, null, 8, _hoisted_4),
          _createTextVNode(" " + _toDisplayString(chain), 1)
        ], 2)
      }), 64))
    ])
  ]))
}
}

})